module.exports = __webpack_public_path__ + "static/media/MIR_3557_Trans_966x644.72c6b34c.png";